/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const dealflowVerifiedCriterionDtoSchema = z.object({
  label: z.optional(z.string()),
  subItems: z.optional(z.array(z.string())),
  decision: z.optional(z.string()),
  justification: z.optional(z.string()),
});
